export default __webpack_public_path__ + "static/media/Layer-639.17467b79.png";